export default "__VITE_ASSET__iwJXMYRr__"